function ready(callbackFunc) {
  if (document.readyState !== 'loading') {
    // Document is already ready, call the callback directly
    callbackFunc();
  } else if (document.addEventListener) {
    // All modern browsers to register DOMContentLoaded
    document.addEventListener('DOMContentLoaded', callbackFunc);
  } else {
    // Old IE browsers
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState === 'complete') {
        callbackFunc();
      }
    });
  }
}

ready(function() {
  /*
    clipboard.js + bootstrap tooltips  
  */  

  
  /*
    Mobile Nav Slidout
  */
  
  function initSlideout(){
    
    const slideout = new Slideout({
      'panel': document.getElementById('main'),
      'menu': document.querySelector('.nav-mobile'),
      'padding': 256,
      'tolerance': 70
    });
    
    const transition = 'transform 300ms ease';
    const translate_open = 'translateX(256px)';
    const translate_close = 'translateX(0px)';
  
    // Toggle button
    if (document.querySelector('.btn-nav-toggle')){
      document.querySelector('.btn-nav-toggle').addEventListener('click', function() {
        slideout.toggle();
      });
    }
    
    const header_core = document.querySelector('.header-core');
    const slideout_items = document.querySelectorAll('.slideout-item');
    const footer = document.querySelector('footer');
    const menu = document.querySelector('.nav-mobile');
    
    slideout
    .on('translate', function(translated) {
      doSlideout(slideout_items,'','translateX(' + translated + 'px)');
    })
    .on('beforeopen', function () {
      this.panel.classList.add('panel-open');
      slideout_items.forEach(function (slideout_item, index) {
        slideout_item.classList.add('panel-open');
      });
      doSlideout(slideout_items,'transform 300ms ease',translate_open); 
      menu.style.opacity = 1;
    })
    .on('open', function() {
      this.panel.addEventListener('click', close);
      slideout_items.forEach(function (slideout_item, index) {
        slideout_item.addEventListener('click', closeSlideout);
      });
    })
    .on('beforeclose', function () {   
      this.panel.classList.remove('panel-open');
      this.panel.removeEventListener('click', closeSlideout);
      slideout_items.forEach(function (slideout_item, index) {
        slideout_item.classList.remove('panel-open');
        slideout_item.removeEventListener('click', closeSlideout);
      });
      doSlideout(slideout_items,'transform 300ms ease',translate_close);
    });

    
    function closeSlideout(eve) {
      eve.preventDefault();
      slideout.close();
    }
    
    
  } // end initSlideout();
 
    
  function doSlideout(element = '', transition = '', transform = ''){    
    element.forEach(function (myElement, index) {
      myElement.style.transition = transition;
      myElement.style.transform = transform;
    });
    return;
  }
  
  function initTypeform(){
    if (document.getElementById('typeform-embed')){
      let window_height = window.innerHeight;      
      let footer_height = document.querySelector('footer').offsetHeight;
      let header_height = document.querySelector('.header-core').offsetHeight;
            
      const typeform_embed = document.getElementById('typeform-embed');
            
      if (viewportWidth < 769){
        header_height = document.querySelector('.header-mobile').offsetHeight;
      }
      
      let embed_height = window_height - header_height;

      
      typeform_embed.style.height = embed_height + 'px';
      
      return;
      
    }
  }
  
  function initModal(){
    if (document.getElementById('event-modal')){
      let eventModal = document.getElementById('event-modal');
      eventModal.addEventListener('show.bs.modal', function (event) {        
        let trigger = event.relatedTarget;
        let trigger_title = trigger.getAttribute('data-modal-title');
        let trigger_content = trigger.querySelector(trigger.getAttribute('data-modal-content'));        
        eventModal.querySelector('.modal-title').innerHTML = trigger_title;
        
        console.log(trigger_title);
        
        eventModal.querySelector('.modal-body').innerHTML = trigger_content.outerHTML;   
        
        document.querySelector('html').classList.add('modal-open');
                    
      });      
      
      eventModal.addEventListener('hide.bs.modal', function (event) { 
        document.querySelector('html').classList.remove('modal-open');        
      });
    }
  }
  
  /*
    Add ".active" class if item is in view for mobile scroll  
  */
  function initScrollView(){
    let scroll_items = document.querySelectorAll('.scroll-item');    
    scroll_items.forEach(function (scroll_item, index) {
      window.addEventListener('scroll', function (event) {
        if (isInViewport(scroll_item)) {
          scroll_item.classList.add('active');
        }else{
          scroll_item.classList.remove('active');
        }
      }, false);
    });    
  }
  
  function isInViewport(element){
    var bounding = element.getBoundingClientRect();
    
    // Checking part. Here the code checks if it's *fully* visible
    // Edit this part if you just want a partial visibility
    if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
        return true;
    } else {
        return false;
    }
  }
  
 
  
  
  // ---------- BROWSER SIZE LISTENER
  
  // Define our viewportWidth variable
  let viewportWidth;
  let globalFormID;
  let subFormType;
  
  // Set/update the viewportWidth value
  let setViewportWidth = function () {
  	viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  	if (viewportWidth < 769){   	  
    	initSlideout();
    	initScrollView();
  	}
  }
      
  // Set our initial width
  setViewportWidth();
  
  // On resize events, recalculate and log
  window.addEventListener('resize', function () {
  	setViewportWidth();  	
    initTypeform();
  }, false);
  
  
  // RUN FUNCTIONS
 
  initTypeform();
  initModal();
});


